import React, { useState } from "react";
import { useSelector } from "react-redux";
import HorizontalPanel from "../../../components/HorizontalPanel";
import { Toolbar } from "../../../app/components";
import { Grid } from "@material-ui/core";
import Multiselect from "../../../components/Multiselect";
import { selectAllHelperUsers } from "../../../store/helperStore/helperSelectors";

import classes from './index.module.scss';
import SearchUserDialog from "../../DevicesPage/DeviceOwnership/SearchUserDialog";

const BulkUserFindAndSelect = ({ onUserSelect, onUpdate, userIdList }: { onUserSelect: (event) => void, onUpdate: (userIdList: number[]) => void, userIdList: number[] }) => {
  const [isOpen, setOpen] = useState(false);
  const fullUserList = useSelector(selectAllHelperUsers)

  const onOpenDialog = () => {
    setOpen(true);
  }


  return (
    <HorizontalPanel size={HorizontalPanel.SIZES.WHOLE_SPACE}>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <Toolbar title="Operation details" />
      </HorizontalPanel>
      <HorizontalPanel size={HorizontalPanel.SIZES.REST_SPACE} className={classes.container}>
        <Grid item xs={12}>
          <Multiselect
            title='User list'
            name='ownership'
            fullWidth
            onClick={onOpenDialog}
            items={Multiselect.getValues(fullUserList, 'id', 'fullName')}
            selectedItems={Multiselect.getSelectedValues(fullUserList, userIdList, 'id', 'fullName')}
            onChange={(values: number[]) => onUpdate(values)}
          />
        </Grid>
        <SearchUserDialog
          isOpen={isOpen}
          onClose={() => setOpen(false)}
          onChoose={onUserSelect}
        />
      </HorizontalPanel>
    </HorizontalPanel>
  )
}

export default BulkUserFindAndSelect;